import React, { useEffect, useState } from "react";
import "./Catalog.css";
import api from "../api/axios";
import Header from "../features/Header"

const MainPage = () => {
  const [cars, setCars] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedCar, setSelectedCar] = useState(null);

  const [filters, setFilters] = useState({
    brand: "",
    type: "",
    year: "",
    fuelType: "",
    color: "",
  });

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await api.get("/api/v1/carInfo");
        const serverCars = response.data.cars;

        const formattedCars = serverCars.map((car) => ({
          id: car.CarID,
          name: `${car.FullName}`,
          brand: car.BrandName,
          desc: car.Description || "Тип не вказаний",
          type: car.type,
          typeDesc: car.typeDesc,
          year: car.Year,
          image: car.PhotoPath,
          color: car.Color,
          vin: car.VIN,
          fuelType: car.FuelType,
          enginePower: car.Power,
          engineVolume: car.Volume,
          price: Number(car.Price).toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }),
          mileage: Number(car.Mileage).toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }),
        }));

        setCars(formattedCars);
        setLoading(false);
      } catch (error) {
        console.error("Помилка при завантаженні даних:", error);
        setLoading(false);
      }
    };

    fetchCars();
  }, []);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const filteredCars = cars.filter((car) => {
    return (
      (filters.brand === "" || car.brand === filters.brand) &&
      (filters.type === "" || car.type === filters.type) &&
      (filters.year === "" || car.year.toString() === filters.year) &&
      (filters.fuelType === "" || car.fuelType === filters.fuelType) &&
      (filters.color === "" || car.color === filters.color)
    );
  });

  const uniqueBrands = [...new Set(cars.map((c) => c.brand))];
  const uniqueTypes = [...new Set(cars.map((c) => c.type))];
  const uniqueYears = [...new Set(cars.map((c) => c.year.toString()))].sort((a, b) => b - a);
  const uniqueFuelTypes = [...new Set(cars.map((c) => c.fuelType))];
  const uniqueColors = [...new Set(cars.map((c) => c.color))];

  if (isLoading) {
    return <div className="loading">Завантаження даних...</div>;
  }

  return (
    <>
      <Header />
      <div className="main-container">
        <h1 className="main-title">Каталог автомобілів</h1>

        <div className="filters">
          <select
            name="brand"
            onChange={handleFilterChange}
            value={filters.brand}
          >
            <option value="">Марка</option>
            {uniqueBrands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>

          <select name="type" onChange={handleFilterChange} value={filters.type}>
            <option value="">Тип</option>
            {uniqueTypes.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>

          <select name="year" onChange={handleFilterChange} value={filters.year}>
            <option value="">Рік</option>
            {uniqueYears.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>

          <select name="fuelType" onChange={handleFilterChange} value={filters.fuelType}>
            <option value="">Тип пального</option>
            {uniqueFuelTypes.map((f) => (
              <option key={f} value={f}>
                {f}
              </option>
            ))}
          </select>

          <select name="color" onChange={handleFilterChange} value={filters.color}>
            <option value="">Колір</option>
            {uniqueColors.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        <div className="car-grid">
          {filteredCars.length ? (
            filteredCars.map((car) => (
              <div key={car.id} className="car-card">
                <img src={car.image} alt={car.name} className="car-image" />
                <h2>{car.name}</h2>
                <p><strong>Марка:</strong> {car.brand}</p>
                <p><strong>Опис:</strong> {car.desc}</p>
                <p><strong>Рік:</strong> {car.year}</p>
                <button
                  className="details-btn"
                  onClick={() => setSelectedCar(car)}
                >
                  Детальніше
                </button>
              </div>
            ))
          ) : (
            <p className="no-results">Автомобілі не знайдені за фільтром.</p>
          )}
        </div>

        {selectedCar && (
          <div className="modal-overlay">
            <div className="modal" onClick={() => setSelectedCar(null)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <span className="close-btn" onClick={() => setSelectedCar(null)}>
                  &times;
                </span>
                <img src={selectedCar.image} alt={selectedCar.name} className="modal-image" />
                <h2>{selectedCar.name}</h2>
                <p><strong>Марка:</strong> {selectedCar.brand}</p>
                <p><strong>Тип:</strong> {selectedCar.type} — {selectedCar.typeDesc}</p>
                <p><strong>Опис:</strong> {selectedCar.desc}</p>
                <p><strong>Рік:</strong> {selectedCar.year}</p>
                <p><strong>Колір:</strong> {selectedCar.color}</p>
                <p><strong>VIN:</strong> {selectedCar.vin}</p>
                <p><strong>Тип пального:</strong> {selectedCar.fuelType}</p>
                <p><strong>Двигун:</strong> {selectedCar.enginePower} к.с | {selectedCar.engineVolume} об'єм</p>
                <p><strong>Ціна:</strong> {selectedCar.price} грн.</p>
                <p><strong>Пробіг:</strong> {selectedCar.mileage} км.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MainPage;
